import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { Location, WorkspaceId } from 'honeygrid-types'

export const locationsQueryKey = (workspaceId?: WorkspaceId) => ['locations', workspaceId] as const

interface LocationsParams {
	workspaceId?: WorkspaceId
}

export const useLocations = ({ workspaceId }: LocationsParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Location[]>({
		queryKey: locationsQueryKey(workspaceId),
		queryFn: (): Promise<Location[]> => authFetch(`workspaces/${workspaceId}/locations`),
		enabled: !!workspaceId,
	})
}
